<template>
   <vx-card class="mb-8" title-color="black" >
    <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        :context="context"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="getColumnDefs"
        :defaultColDef="defaultColDef"
        :rowData="getModels"
        colResizeDefault="shift"
        :animateRows="true" 
        :pagination="false"
        :suppressPaginationPanel="true"
        :key="agGridKey"
        :enableRtl="$vs.rtl">
    </ag-grid-vue>
   </vx-card>
</template>
<script>

import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import ResourceTypeEnum from "../../ResourceTypeEnum.js"
import ResourceCategoryEnum from '../../ResourceCategoryEnum.js';

export default {
  name:"StatementComparisonGrid",  
  components: {
    AgGridVue
  },
  props: {
    tableData: {
      type: Array,
      required: true
    },
    summaryTableData: {
      type: Array,
      required: true
    },
    selectedStatementName: {
      type: String
    },
    comparisonStatementName: {
      type: String
    }
  },
  data() {
    return {
      defaultColDef: {
        sortable: false,
        resizable: false        
      },
      gridApi: null,
      gridOptions: {
        applyColumnDefOrder: true,
        getRowNodeId: (data) => {
          return data.name;
        }
      },
      context: { componentParent: this },
      columnDefs: [
        {
          headerName: this.$t('MRMR.Statement.Period'),
          field: "name",
          width: 165
        },
        {
          headerName: this.$t('MRMR.ResourceTypeFullName.' + ResourceTypeEnum.Proven),
          children: [
            { 
              field: 'provenTonnage',
              headerName: this.$t('MRMR.Entry.Tonnage'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            },
            { 
              field: 'provenAuGrade',
              headerName:  this.$t('MRMR.Statement.AuGradeShort'),
              valueFormatter: this.formatGrade,
              type: 'rightAligned',
              width: 140
            }, 
            { 
              field: 'provenAuOz',
              headerName:  this.$t('MRMR.Statement.AuOzShort'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            }
          ]
        },
        {
          headerName: this.$t('MRMR.ResourceTypeFullName.' + ResourceTypeEnum.Probable),
          children: [
            { 
              field: 'probableTonnage',
              headerName: this.$t('MRMR.Entry.Tonnage'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            },
            { 
              field: 'probableAuGrade',
              headerName:  this.$t('MRMR.Statement.AuGradeShort'),
              valueFormatter: this.formatGrade,
              type: 'rightAligned',
              width: 140
            }, 
            { 
              field: 'probableAuOz',
              headerName:  this.$t('MRMR.Statement.AuOzShort'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            }
          ]
        },
        {
          headerName: this.$t('MRMR.ResourceTypeFullName.' + ResourceTypeEnum.Measured),
          children: [
            { 
              field: 'measuredTonnage',
              headerName: this.$t('MRMR.Entry.Tonnage'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            },
            { 
              field: 'measuredAuGrade',
              headerName:  this.$t('MRMR.Statement.AuGradeShort'),
              valueFormatter: this.formatGrade,
              type: 'rightAligned',
              width: 140
            }, 
            { 
              field: 'measuredAuOz',
              headerName:  this.$t('MRMR.Statement.AuOzShort'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            }
          ]
        },
        {
          headerName: this.$t('MRMR.ResourceTypeFullName.' + ResourceTypeEnum.Indicated),
          children: [
            { 
              field: 'indicatedTonnage',
              headerName: this.$t('MRMR.Entry.Tonnage'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            },
            { 
              field: 'indicatedAuGrade',
              headerName:  this.$t('MRMR.Statement.AuGradeShort'),
              valueFormatter: this.formatGrade,
              type: 'rightAligned',
              width: 140
            }, 
            { 
              field: 'indicatedAuOz',
              headerName:  this.$t('MRMR.Statement.AuOzShort'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            }
          ]
        },
        {
          headerName: this.$t('MRMR.ResourceTypeFullName.' + ResourceTypeEnum.Inferred),
          children: [
            { 
              field: 'inferredTonnage',
              headerName: this.$t('MRMR.Entry.Tonnage'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            },
            { 
              field: 'inferredAuGrade',
              headerName:  this.$t('MRMR.Statement.AuGradeShort'),
              valueFormatter: this.formatGrade,
              type: 'rightAligned',
              width: 140
            }, 
            { 
              field: 'inferredAuOz',
              headerName:  this.$t('MRMR.Statement.AuOzShort'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            }
          ]
        },
        {
          headerName: this.$t('MRMR.ResourceTypeFullName.' + ResourceTypeEnum.PotentialMineral),
          children: [
            { 
              field: 'potentialMineralTonnage',
              headerName: this.$t('MRMR.Entry.Tonnage'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            },
            { 
              field: 'potentialMineralAuGrade',
              headerName:  this.$t('MRMR.Statement.AuGradeShort'),
              valueFormatter: this.formatGrade,
              type: 'rightAligned',
              width: 140
            }, 
            { 
              field: 'potentialMineralAuOz',
              headerName:  this.$t('MRMR.Statement.AuOzShort'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            }
          ]
        }
      ],
      summaryColumnDefs: [
        {
          headerName: this.$t('MRMR.Statement.Period'),
          field: "name",
          width: 165
        },
        {
          headerName: this.$t('MRMR.ResourceCategories.' + ResourceCategoryEnum.Reserve),
          children: [
            { 
              field: 'reserveTonnage',
              headerName: this.$t('MRMR.Entry.Tonnage'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            },
            { 
              field: 'reserveAuGrade',
              headerName:  this.$t('MRMR.Statement.AuGradeShort'),
              valueFormatter: this.formatGrade,
              type: 'rightAligned',
              width: 140
            }, 
            { 
              field: 'reserveAuOz',
              headerName:  this.$t('MRMR.Statement.AuOzShort'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            }
          ]
        },
        {
          headerName: this.$t('MRMR.ResourceCategories.' + ResourceCategoryEnum.Resource),
          children: [
            { 
              field: 'resourceTonnage',
              headerName: this.$t('MRMR.Entry.Tonnage'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            },
            { 
              field: 'resourceAuGrade',
              headerName:  this.$t('MRMR.Statement.AuGradeShort'),
              valueFormatter: this.formatGrade,
              type: 'rightAligned',
              width: 140
            }, 
            { 
              field: 'resourceAuOz',
              headerName:  this.$t('MRMR.Statement.AuOzShort'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            }
          ]
        },
        {
          headerName: this.$t('MRMR.ResourceCategories.' + ResourceCategoryEnum.Inferred),
          children: [
            { 
              field: 'inferredTonnage',
              headerName: this.$t('MRMR.Entry.Tonnage'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            },
            { 
              field: 'inferredAuGrade',
              headerName:  this.$t('MRMR.Statement.AuGradeShort'),
              valueFormatter: this.formatGrade,
              type: 'rightAligned',
              width: 140
            }, 
            { 
              field: 'inferredAuOz',
              headerName:  this.$t('MRMR.Statement.AuOzShort'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            }
          ]
        },
        {
          headerName: this.$t('MRMR.ResourceCategories.' + ResourceCategoryEnum.PotentialMineral),
          children: [
            { 
              field: 'potentialMineralTonnage',
              headerName: this.$t('MRMR.Entry.Tonnage'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            },
            { 
              field: 'potentialMineralAuGrade',
              headerName:  this.$t('MRMR.Statement.AuGradeShort'),
              valueFormatter: this.formatGrade,
              type: 'rightAligned',
              width: 140
            }, 
            { 
              field: 'potentialMineralAuOz',
              headerName:  this.$t('MRMR.Statement.AuOzShort'),
              valueFormatter: this.formatTonnage,
              type: 'rightAligned',
              width: 140
            }
          ]
        }
      ],
      detailedModels : [],
      summaryModels : [],
      agGridKey: 0
    }
  },
  watch: {
    tableData(val) {
      if (val.length > 0) {
        this.fillTableModels(val);
        this.gridOptions.api.setColumnDefs(this.columnDefs);
        this.agGridKey++;
      }
      else
        this.models = [];
    },    
    summaryTableData(val) {
      if (val.length > 0) {
        this.agGridKey++;
        this.fillSummaryTableModels(val);
        this.gridOptions.api.setColumnDefs(this.summaryColumnDefs);
      }
      else
        this.models = [];
    }
  },
  computed: {
    getColumnDefs() {
      if (this.tableData.length > 0)
        return this.columnDefs;
      else
        return this.summaryColumnDefs;
    },
    getModels() {
      if (this.detailedModels.length > 0)
        return this.detailedModels;
      else
        return this.summaryModels;
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
  methods : {
    formatTonnage(params) {
      if (params.node.rowIndex !== 3) {
        return this.$options.filters.toMRMRTonnage(params.value);
      } else {
        return this.$options.filters.toPercentage(params.value);
      }
    },
    formatGrade(params) {
      if (params.node.rowIndex < 2) {
        return this.$options.filters.toFriendlyGrade(params.value);
      } else if (params.node.rowIndex === 2) {
        return this.$options.filters.toFriendlyDiffGrade(params.value);
      } else {
        return this.$options.filters.toPercentage(params.value);
      }
    },
    fillTableModels(modelTables) {
      this.summaryModels = [];
      this.detailedModels = [];
      const selectedModel = { name : this.$props.selectedStatementName };
      const provenResource = modelTables.find(m => m.resource === ResourceTypeEnum.Proven);

      selectedModel.provenTonnage = provenResource.selectedTonnage;
      selectedModel.provenAuOz = provenResource.selectedAuOZ;
      selectedModel.provenAuGrade = provenResource.selectedAuGrade;

      const probableResource = modelTables.find(m => m.resource === ResourceTypeEnum.Probable);

      selectedModel.probableTonnage = probableResource.selectedTonnage;
      selectedModel.probableAuOz = probableResource.selectedAuOZ;
      selectedModel.probableAuGrade = probableResource.selectedAuGrade;

      const measuredResource = modelTables.find(m => m.resource === ResourceTypeEnum.Measured);

      selectedModel.measuredTonnage = measuredResource.selectedTonnage;
      selectedModel.measuredAuOz = measuredResource.selectedAuOZ;
      selectedModel.measuredAuGrade = measuredResource.selectedAuGrade;

      const indicatedResource = modelTables.find(m => m.resource === ResourceTypeEnum.Indicated);

      selectedModel.indicatedTonnage = indicatedResource.selectedTonnage;
      selectedModel.indicatedAuOz = indicatedResource.selectedAuOZ;
      selectedModel.indicatedAuGrade = indicatedResource.selectedAuGrade;

      const inferredResource = modelTables.find(m => m.resource === ResourceTypeEnum.Inferred);

      selectedModel.inferredTonnage = inferredResource.selectedTonnage;
      selectedModel.inferredAuOz = inferredResource.selectedAuOZ;
      selectedModel.inferredAuGrade = inferredResource.selectedAuGrade;

      const potentialMineralResource = modelTables.find(m => m.resource === ResourceTypeEnum.PotentialMineral);

      selectedModel.potentialMineralTonnage = potentialMineralResource.selectedTonnage;
      selectedModel.potentialMineralAuOz = potentialMineralResource.selectedAuOZ;
      selectedModel.potentialMineralAuGrade = potentialMineralResource.selectedAuGrade;
      
      this.detailedModels.push(selectedModel);

      if (this.$props.comparisonStatementName !== '') {
        const comparedModel = { name : this.$props.comparisonStatementName };
        const diffModel = { name : "Diff" };
        const varianceModel = { name : "Var"};

        comparedModel.provenTonnage = provenResource.comparisonTonnage;
        comparedModel.provenAuOz = provenResource.comparisonAuOZ;
        comparedModel.provenAuGrade = provenResource.comparisonAuGrade;
        diffModel.provenTonnage = provenResource.diffTonnage;
        diffModel.provenAuOz = provenResource.diffAuOZ;
        diffModel.provenAuGrade = provenResource.diffAuGrade;
        varianceModel.provenTonnage = provenResource.varianceTonnage;
        varianceModel.provenAuOz = provenResource.varianceAuOZ;
        varianceModel.provenAuGrade = provenResource.varianceAuGrade;

        comparedModel.probableTonnage = probableResource.comparisonTonnage;
        comparedModel.probableAuOz = probableResource.comparisonAuOZ;
        comparedModel.probableAuGrade = probableResource.comparisonAuGrade;
        diffModel.probableTonnage = probableResource.diffTonnage;
        diffModel.probableAuOz = probableResource.diffAuOZ;
        diffModel.probableAuGrade = probableResource.diffAuGrade;
        varianceModel.probableTonnage = probableResource.varianceTonnage;
        varianceModel.probableAuOz = probableResource.varianceAuOZ;
        varianceModel.probableAuGrade = probableResource.varianceAuGrade;

        comparedModel.measuredTonnage = measuredResource.comparisonTonnage;
        comparedModel.measuredAuOz = measuredResource.comparisonAuOZ;
        comparedModel.measuredAuGrade = measuredResource.comparisonAuGrade;
        diffModel.measuredTonnage = measuredResource.diffTonnage;
        diffModel.measuredAuOz = measuredResource.diffAuOZ;
        diffModel.measuredAuGrade = measuredResource.diffAuGrade;
        varianceModel.measuredTonnage = measuredResource.varianceTonnage;
        varianceModel.measuredAuOz = measuredResource.varianceAuOZ;
        varianceModel.measuredAuGrade = measuredResource.varianceAuGrade;

        comparedModel.indicatedTonnage = indicatedResource.comparisonTonnage;
        comparedModel.indicatedAuOz = indicatedResource.comparisonAuOZ;
        comparedModel.indicatedAuGrade = indicatedResource.comparisonAuGrade;
        diffModel.indicatedTonnage = indicatedResource.diffTonnage;
        diffModel.indicatedAuOz = indicatedResource.diffAuOZ;
        diffModel.indicatedAuGrade = indicatedResource.diffAuGrade;
        varianceModel.indicatedTonnage = indicatedResource.varianceTonnage;
        varianceModel.indicatedAuOz = indicatedResource.varianceAuOZ;
        varianceModel.indicatedAuGrade = indicatedResource.varianceAuGrade;

        comparedModel.inferredTonnage = inferredResource.comparisonTonnage;
        comparedModel.inferredAuOz = inferredResource.comparisonAuOZ;
        comparedModel.inferredAuGrade = inferredResource.comparisonAuGrade;
        diffModel.inferredTonnage = inferredResource.diffTonnage;
        diffModel.inferredAuOz = inferredResource.diffAuOZ;
        diffModel.inferredAuGrade = inferredResource.diffAuGrade;
        varianceModel.inferredTonnage = inferredResource.varianceTonnage;
        varianceModel.inferredAuOz = inferredResource.varianceAuOZ;
        varianceModel.inferredAuGrade = inferredResource.varianceAuGrade;

        comparedModel.potentialMineralTonnage = potentialMineralResource.comparisonTonnage;
        comparedModel.potentialMineralAuOz = potentialMineralResource.comparisonAuOZ;
        comparedModel.potentialMineralAuGrade = potentialMineralResource.comparisonAuGrade;
        diffModel.potentialMineralTonnage = potentialMineralResource.diffTonnage;
        diffModel.potentialMineralAuOz = potentialMineralResource.diffAuOZ;
        diffModel.potentialMineralAuGrade = potentialMineralResource.diffAuGrade;
        varianceModel.potentialMineralTonnage = potentialMineralResource.varianceTonnage;
        varianceModel.potentialMineralAuOz = potentialMineralResource.varianceAuOZ;
        varianceModel.potentialMineralAuGrade = potentialMineralResource.varianceAuGrade;

        this.detailedModels.push(comparedModel);
        this.detailedModels.push(diffModel);
        this.detailedModels.push(varianceModel);
      }
    },
    fillSummaryTableModels(modelTables) {
      this.summaryModels = [];
      this.detailedModels = [];
      const selectedModel = { name : this.$props.selectedStatementName };
      const reserve = modelTables.find(m => m.resource === ResourceCategoryEnum.Reserve);

      selectedModel.reserveTonnage = reserve.selectedTonnage;
      selectedModel.reserveAuOz = reserve.selectedAuOZ;
      selectedModel.reserveAuGrade = reserve.selectedAuGrade;

      const resource = modelTables.find(m => m.resource === ResourceCategoryEnum.Resource);

      selectedModel.resourceTonnage = resource.selectedTonnage;
      selectedModel.resourceAuOz = resource.selectedAuOZ;
      selectedModel.resourceAuGrade = resource.selectedAuGrade;

      const inferred = modelTables.find(m => m.resource === ResourceCategoryEnum.Inferred);

      selectedModel.inferredTonnage = inferred.selectedTonnage;
      selectedModel.inferredAuOz = inferred.selectedAuOZ;
      selectedModel.inferredAuGrade = inferred.selectedAuGrade;

      const potentialMineral = modelTables.find(m => m.resource === ResourceCategoryEnum.PotentialMineral);

      selectedModel.potentialMineralTonnage = potentialMineral.selectedTonnage;
      selectedModel.potentialMineralAuOz = potentialMineral.selectedAuOZ;
      selectedModel.potentialMineralAuGrade = potentialMineral.selectedAuGrade;
      

      this.summaryModels.push(selectedModel);

      if (this.$props.comparisonStatementName !== '') {
        const comparedModel = { name : this.$props.comparisonStatementName };
        const diffModel = { name : "Diff" };
        const varianceModel = { name : "Var"};

        comparedModel.reserveTonnage = reserve.comparisonTonnage;
        comparedModel.reserveAuOz = reserve.comparisonAuOZ;
        comparedModel.reserveAuGrade = reserve.comparisonAuGrade;
        diffModel.reserveTonnage = reserve.diffTonnage;
        diffModel.reserveAuOz = reserve.diffAuOZ;
        diffModel.reserveAuGrade = reserve.diffAuGrade;
        varianceModel.reserveTonnage = reserve.varianceTonnage;
        varianceModel.reserveAuOz = reserve.varianceAuOZ;
        varianceModel.reserveAuGrade = reserve.varianceAuGrade;

        comparedModel.resourceTonnage = resource.comparisonTonnage;
        comparedModel.resourceAuOz = resource.comparisonAuOZ;
        comparedModel.resourceAuGrade = resource.comparisonAuGrade;
        diffModel.resourceTonnage = resource.diffTonnage;
        diffModel.resourceAuOz = resource.diffAuOZ;
        diffModel.resourceAuGrade = resource.diffAuGrade;
        varianceModel.resourceTonnage = resource.varianceTonnage;
        varianceModel.resourceAuOz = resource.varianceAuOZ;
        varianceModel.resourceAuGrade = resource.varianceAuGrade;

        comparedModel.inferredTonnage = inferred.comparisonTonnage;
        comparedModel.inferredAuOz = inferred.comparisonAuOZ;
        comparedModel.inferredAuGrade = inferred.comparisonAuGrade;
        diffModel.inferredTonnage = inferred.diffTonnage;
        diffModel.inferredAuOz = inferred.diffAuOZ;
        diffModel.inferredAuGrade = inferred.diffAuGrade;
        varianceModel.inferredTonnage = inferred.varianceTonnage;
        varianceModel.inferredAuOz = inferred.varianceAuOZ;
        varianceModel.inferredAuGrade = inferred.varianceAuGrade;

        comparedModel.potentialMineralTonnage = potentialMineral.comparisonTonnage;
        comparedModel.potentialMineralAuOz = potentialMineral.comparisonAuOZ;
        comparedModel.potentialMineralAuGrade = potentialMineral.comparisonAuGrade;
        diffModel.potentialMineralTonnage = potentialMineral.diffTonnage;
        diffModel.potentialMineralAuOz = potentialMineral.diffAuOZ;
        diffModel.potentialMineralAuGrade = potentialMineral.diffAuGrade;
        varianceModel.potentialMineralTonnage = potentialMineral.varianceTonnage;
        varianceModel.potentialMineralAuOz = potentialMineral.varianceAuOZ;
        varianceModel.potentialMineralAuGrade = potentialMineral.varianceAuGrade;

        this.summaryModels.push(comparedModel);
        this.summaryModels.push(diffModel);
        this.summaryModels.push(varianceModel);
      }
    }
  }
};
</script>
<style lang="scss">
#Stats-results-grid-view {
   .ag-header-group-text {
     text-align: center;
     border: 1px;
   }
   .ag-header-group-cell-label {
     align-content: center;
   }
}
  </style>
